import { render, staticRenderFns } from "./UserCompetitionsProposed.vue?vue&type=template&id=1ff14f2c&scoped=true&"
import script from "./UserCompetitionsProposed.vue?vue&type=script&lang=js&"
export * from "./UserCompetitionsProposed.vue?vue&type=script&lang=js&"
import style0 from "./UserCompetitionsProposed.vue?vue&type=style&index=0&id=1ff14f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff14f2c",
  null
  
)

export default component.exports